"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreakType = void 0;
var StreakType;
(function (StreakType) {
    StreakType[StreakType["WIN"] = 0] = "WIN";
    StreakType[StreakType["LOSS"] = 1] = "LOSS";
})(StreakType || (exports.StreakType = StreakType = {}));
